import React from 'react';
import {NonHatchShiftingActivity as NHA, Shiploader} from '@deckmans/domain';
import {ActivityListItem} from './ActivityListItem';
import {useHistory} from 'react-router';

export interface NonHatchActivityProps {
  nonHatchShiftingActivity: NHA;
  vesselId: string;
  id?: string;
  startDate?: Date;
  endDate?: Date;
  shiploader: Shiploader;
}
export function NonHatchShiftingActivityComp({
  nonHatchShiftingActivity,
  vesselId,
  startDate,
  endDate,
  shiploader,
  id,
}: NonHatchActivityProps) {
  const {reason} = nonHatchShiftingActivity;
  const history = useHistory();

  return (
    <ActivityListItem
      color="info"
      title="Shifting"
      subtitle={reason}
      startTime={startDate}
      endTime={endDate}
      editItem={() => {
        history.push(
          `/activity/non-hatch-activity/edit/${shiploader}/${vesselId}/${id}`
        );
      }}
    />
  );
}
